import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

interface UseBulkActionsEntryUpdateTemplateProps {
  entryId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useBulkActionsEntryUpdateTemplate = ({
  entryId,
  onSuccess,
  onError,
}: UseBulkActionsEntryUpdateTemplateProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['bulkActionsEntryUpdateTemplate', entryId],
    mutationFn: () => {
      if (!entryId) throw new Error('entryId is required');
      return privateAxios.put(`/bulk_actions/entries/${entryId}/update_template`);
    },
    onSuccess,
    onError,
  });
}; 